import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /** Line label text. */
  label: string;
  /** Amount value to display. */
  value?: number;
  /** If `true`, the line will be rendered with a slightly larger font. */
  large?: boolean;
  /** If `true`, a loading indicator will display instead of the value. */
  loading?: boolean;
  /** If `true`, the text "Pending" will display instead of the value. */
  pending?: boolean;
}


import { ref, watch } from 'vue';

import { delay } from '@tools/delay';

import DisplayTextCurrency from '@components/Display/DisplayTextCurrency.vue';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TotalLine: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TotalLine' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: null,
    value: null,
    large: { type: Boolean },
    loading: { type: Boolean },
    pending: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  /** Line label text. */
  label: string;
  /** Amount value to display. */
  value?: number;
  /** If `true`, the line will be rendered with a slightly larger font. */
  large?: boolean;
  /** If `true`, a loading indicator will display instead of the value. */
  loading?: boolean;
  /** If `true`, the text "Pending" will display instead of the value. */
  pending?: boolean;
};

/**
 * `TotalLine` component properties.
 */


const valueChanged = ref(false);

async function onValueChanged() {
  valueChanged.value = true;

  await delay(150);

  valueChanged.value = false;
}

watch(() => props.value, onValueChanged);

return { __sfc: true,props, valueChanged, onValueChanged, DisplayTextCurrency }
}

})